import styles from "./styles.module.scss"

export const FilterSortDropdown = ({
  options,
  onClick,
}: {
  options: { id: string; label: string; testId?: string }[]
  onClick: (option: { id: string; label: string }) => void
}) => {
  return (
    <div className={styles.container}>
      {options.map((option) => (
        <button
          key={option.id}
          onClick={() => onClick(option)}
          className={styles.button}
          data-testid={option.testId}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
